/* Вкладка «Озвучка». Оболочка и список голосов — экран React.
   Список — общий виджет колонки: разметка кладётся в #vp целиком, быстрый поиск каркаса
   перехватывает эту вставку и меняет выдачу на месте. */
import { VoiceListBody } from './VoiceListBody';
import { attachTts, destroyTts, setVoiceCommit } from './runtime';
import { clearHistoryRepeat, readHistoryRepeat } from '../../bridge/history-repeat';

/** «Повторить» из Истории: как в шаблоне — вкладка с прежним голосом. Текст пишется в чат, поэтому из повтора берётся только голос;
    выбор отмечается в списке, а сохраняется на сервере лишь нажатием на голос */
function adoptRepeat() {
  const repeat = readHistoryRepeat('tts');
  if (!repeat) return;
  clearHistoryRepeat();
  const id = repeat.voice_id ?? Number(repeat.inputs?.voice_id);
  const shell = (window as unknown as { BotChatTts?: { setVoice(id: number | null): void } }).BotChatTts;
  if (Number.isSafeInteger(id) && id > 0) shell?.setVoice(id);
}

function VoiceColumn() {
  return (
    <VoiceListBody
      id="vp"
      bind={commit => {
        setVoiceCommit(commit);
        adoptRepeat();
        attachTts();
        return () => {
          destroyTts();
          setVoiceCommit(null);
        };
      }}
    />
  );
}

export function Tts() {
  return (
    <section className="tts" id="tts">
      <div className="tts-cat">
        <VoiceColumn />
      </div>
    </section>
  );
}
